
import * as types from './mutations_types'
import { store,localStorage } from '../../utils/';

export default {
  [types.update_sessionId](state, data) {
    state.sessionId = data;
	},

  [types.update_changeSessionIdMethod](state, data) {
    state.changeSessionIdMethod = data;
	},

  [types.update_isChange](state, data) {
    state.isChange = data;
    
  },

  [types.update_newSessionMethod](state, data) {
    state.newSessionMethod = data;

  },

  [types.update_refreshSessionListMethod](state, data) {
    state.refreshSessionListMethod = data;

  },

  [types.update_baseModel](state, data) {
    state.baseModel = data;
    store.set('baseModel', state.baseModel);
  },

  [types.update_enhancedModel](state, data) {
    state.enhancedModel = data;
    store.set('enhancedModel', state.enhancedModel);
  },

  [types.update_modelType](state, data) {
    state.modelType = data;
  },

  [types.update_submitMsg](state, data) {
    state.submitMsg = data;
  },

  [types.update_submitFileList](state, data) {
    state.submitFileList = data;
  },


  [types.update_chatType](state, data) {
    state.chatType = data;
    localStorage.set('chatType', state.chatType);
  },
  
  
  
};